/**
 * Portfolio actions
 */
export const PORTFOLIO_ACTIONS = {
  ONBOARDING_STEP: 'onboarding_step',
  SETTINGS_OPENED: 'settings_opened',
  SETTINGS_CLOSED: 'settings_closed',
  CONFIG_SAVED: 'config_saved',
  CONFIG_TAB_CHANGED: 'config_tab_changed',
  HOLDING_SELECTED: 'holding_selected',
  HOLDING_SLIDEOUT_OPENED: 'holding_slideout_opened',
  HOLDING_SLIDEOUT_CLOSED: 'holding_slideout_closed',
  HOLDING_TAB_CHANGED: 'holding_tab_changed',
  FILTER_CHANGED: 'filter_changed',
  GROUPING_CHANGED: 'grouping_changed',
  ORG_SWITCHED: 'org_switched',
  CASHFLOW_ADDED: 'cashflow_added',
  CASHFLOW_DELETED: 'cashflow_deleted',
  CASHFLOW_PASTED: 'cashflow_pasted',
  SEARCH_PERFORMED: 'search_performed',
  EDIT_MODE_TOGGLED: 'edit_mode_toggled',
  METRIC_OVERRIDE_SET: 'metric_override_set',
  METRIC_OVERRIDE_RESET: 'metric_override_reset',
  SECTION_SAVED: 'section_saved',
  TAB_CHANGED: 'tab_changed',
  CHART_DRILL_DOWN: 'chart_drill_down',
  EXPORT_CSV: 'export_csv',
  EXPORT_EXCEL: 'export_excel',
} as const;
